import React from 'react';
import styles from './layout-container.module.scss';
import { LayoutContainerProps } from './types';

const LayoutContainer = ({
  className = '',
  children = null,
}: LayoutContainerProps) => (
  <div className={styles.layout}>
    <div className={`${styles.layout__container} ${className}`.trim()}>
      {children}
    </div>
  </div>
);

export default LayoutContainer;
